import { render, staticRenderFns } from "./LimitList.vue?vue&type=template&id=8d8a127c&scoped=true&"
import script from "./LimitList.vue?vue&type=script&lang=js&"
export * from "./LimitList.vue?vue&type=script&lang=js&"
import style0 from "./LimitList.vue?vue&type=style&index=0&id=8d8a127c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a127c",
  null
  
)

export default component.exports